import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=304f0b7c&scoped=true&"
import script from "./ViewProfile.vue?vue&type=script&lang=js&"
export * from "./ViewProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=304f0b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f0b7c",
  null
  
)

export default component.exports